/* PawPeak/SmoothLift — pawpeak-theme.js */
(function(){'use strict';

var TRASH_ICON = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>';

/* Nav drawer */
var menuBtn=document.getElementById('lume-menu-btn');
var drawer=document.getElementById('lume-nav-drawer');
var drawerClose=document.getElementById('pp-drawer-close')||document.querySelector('.lume-drawer__close');
var drawerOverlay=drawer&&drawer.querySelector('.lume-drawer__overlay');
function openDrawer(){if(!drawer)return;drawer.classList.add('is-open');document.body.style.overflow='hidden';}
function closeDrawer(){if(!drawer)return;drawer.classList.remove('is-open');document.body.style.overflow='';}
menuBtn&&menuBtn.addEventListener('click',openDrawer);
drawerClose&&drawerClose.addEventListener('click',closeDrawer);
drawerOverlay&&drawerOverlay.addEventListener('click',closeDrawer);
document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeDrawer();closeCart();}});

/* Cart drawer */
var cartBtn=document.getElementById('lume-cart-btn');
var cartDrawer=document.getElementById('lume-cart-drawer');
var cartOverlay=document.getElementById('lume-cart-overlay');
var cartClose=document.getElementById('lume-cart-close');
function openCart(){if(!cartDrawer)return;fetchCart();cartDrawer.classList.add('is-open');cartOverlay&&cartOverlay.classList.add('is-visible');document.body.style.overflow='hidden';}
function closeCart(){if(!cartDrawer)return;cartDrawer.classList.remove('is-open');cartOverlay&&cartOverlay.classList.remove('is-visible');document.body.style.overflow='';}
cartBtn&&cartBtn.addEventListener('click',openCart);
cartClose&&cartClose.addEventListener('click',closeCart);
cartOverlay&&cartOverlay.addEventListener('click',closeCart);

function fmt(c){return '$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
function updateCount(n){
  var el=document.getElementById('lume-cart-count');
  if(!el)return;
  el.textContent=n;
  el.style.display=n>0?'flex':'none';
}

function fetchCart(){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(d){updateCount(d.item_count);renderCart(d);}).catch(console.error);
}

function renderCart(cart){
  if(!cartDrawer)return;
  var body=document.getElementById('lume-cart-body');
  var subEl=cartDrawer.querySelector('.lume-cart-drawer__subtotal-amount');
  var shipEl=cartDrawer.querySelector('.lume-cart-drawer__shipping-note');
  if(!body)return;

  if(cart.item_count===0){
    body.innerHTML='<p class="lume-cart-drawer__empty">Your cart is empty.<br><a href="/collections/lume" style="text-decoration:underline">Shop SmoothLift</a></p>';
  } else {
    var html='<ul class="lume-cart-items">';
    cart.items.forEach(function(item){
      html+='<li class="lume-cart-item">';
      html+='<div class="lume-cart-item__media">';
      if(item.featured_image&&item.featured_image.url){
        html+='<img src="'+item.featured_image.url+'" width="70" height="70" loading="lazy" alt="'+item.title+'">';
      }
      html+='</div>';
      html+='<div class="lume-cart-item__info">';
      html+='<p class="lume-cart-item__title">'+item.product_title+'</p>';
      if(item.variant_title&&item.variant_title!=='Default Title'){
        html+='<p class="lume-cart-item__variant">'+item.variant_title+'</p>';
      }
      html+='<div class="lume-cart-item__qty-wrap">';
      html+='<button class="lume-qty-btn" data-key="'+item.key+'" data-qty="'+(item.quantity-1)+'">&#8722;</button>';
      html+='<span class="lume-cart-item__qty">'+item.quantity+'</span>';
      html+='<button class="lume-qty-btn" data-key="'+item.key+'" data-qty="'+(item.quantity+1)+'">+</button>';
      html+='<button class="lume-cart-item__remove" data-key="'+item.key+'" aria-label="Remove item">'+TRASH_ICON+'</button>';
      html+='</div></div>';
      html+='<p class="lume-cart-item__price">'+fmt(item.final_line_price)+'</p>';
      html+='</li>';
    });
    html+='</ul>';
    body.innerHTML=html;

    if(subEl)subEl.textContent=fmt(cart.total_price);
    if(shipEl){
      var need=6000-cart.total_price;
      shipEl.textContent=need>0?'Add '+fmt(need)+' more for free shipping \ud83d\ude9a':'\u2705 Free shipping unlocked!';
    }

    body.querySelectorAll('.lume-qty-btn').forEach(function(b){
      b.addEventListener('click',function(){changeItem(this.dataset.key,parseInt(this.dataset.qty));});
    });
    body.querySelectorAll('.lume-cart-item__remove').forEach(function(b){
      b.addEventListener('click',function(){changeItem(this.dataset.key,0);});
    });
  }
}

function changeItem(key,qty){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
    .then(function(r){return r.json();}).then(function(d){updateCount(d.item_count);renderCart(d);}).catch(console.error);
}

/* ATC form submit */
document.addEventListener('submit',function(e){
  var form=e.target.closest('[data-pp-form],[data-sp-form]');
  if(!form)return;
  e.preventDefault();
  var btn=form.querySelector('[type=submit]');
  if(!btn)return;
  var orig=btn.textContent;
  btn.textContent='Adding...';btn.disabled=true;
  var fd=new FormData();
  var vid=document.getElementById('sp-vid')||document.getElementById('pp-vid');
  var qty=document.getElementById('sp-qty-hidden')||document.getElementById('sp-qty')||document.getElementById('pp-qty');
  if(vid)fd.append('id',vid.value);
  if(qty)fd.append('quantity',qty.value||'1');
  fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd})
    .then(function(r){return r.json();})
    .then(function(){btn.textContent='Added \u2713';setTimeout(function(){btn.textContent=orig;btn.disabled=false;},1500);fetchCart();openCart();})
    .catch(function(){btn.textContent=orig;btn.disabled=false;});
});

/* Header scroll shadow */
var header=document.querySelector('.lume-header');
header&&window.addEventListener('scroll',function(){header.classList.toggle('scrolled',window.scrollY>12);},{passive:true});

/* Init cart count */
fetch('/cart.js').then(function(r){return r.json();}).then(function(d){updateCount(d.item_count);}).catch(function(){});

})();
